export default __webpack_public_path__ + "static/media/profile.2b26c279.jpg";